"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldRetryQuery = void 0;
const client_1 = require("@trpc/client");
/**
 * Creates a retry checker function compatible with react-query retryer api.
 * A query can be retried if the failure count is less than the maximum number of attempts
 * and the error is a server error or a network error.
 *
 * @param opts.attempts The maximum number of attempts to query the data.
 * @returns The retry checker function.
 */
function shouldRetryQuery(opts) {
    return (failureCount, error) => {
        if (failureCount >= opts.attempts) {
            return false;
        }
        if (!(error instanceof client_1.TRPCClientError)) {
            return false;
        }
        const isServerError = error.data?.httpStatus >= 500;
        const isNetworkError = error.cause?.name === "FetchError";
        return isServerError || isNetworkError;
    };
}
exports.shouldRetryQuery = shouldRetryQuery;
//# sourceMappingURL=should-retry-query.js.map